/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { isArray } from 'lodash';
import { TransactionItemPlaceholder } from '../../../../components/Placeholders';
import CurrencyIcon from '../../../../components/CurrencyIcon';

export const Body = ({ children }) => (
  <div className="col-12 col-md-9 pe-0 ps-sm-0 ps-md-3 mt-xl-0 mt-3">{children}</div>
);

Body.propTypes = {
  children: PropTypes.any.isRequired,
};

export const LeftPanel = ({ children }) => (
  <div className="col-12 col-md-3 ps-0">
    <div className="d-none d-md-flex row">
      {isArray(children) ? (
        children.map((child, index) => (
          <div key={index} className={`col-12 ${index > 0 ? 'mt-3' : ''}`}>
            {child}
          </div>
        ))
      ) : (
        <div className="col-lg-12 col-md-12 col-sm-6">{children}</div>
      )}
    </div>
    <div className="d-flex d-md-none w-100">
      {isArray(children) ? (
        children.map((child, index) => (
          <div key={index} className={`col-12 ${index > 0 ? 'mt-3' : ''}`}>
            {child}
          </div>
        ))
      ) : (
        <div className="col-12">{children}</div>
      )}
    </div>
  </div>
);

LeftPanel.propTypes = {
  children: PropTypes.any.isRequired,
};

export const Filter = ({ children, filters, handleSortLoans }) => (
  <div className="container p-0">
    <div className="px-3">
      <div className="px-3 row d-none d-md-flex">
        {filters.map((filter) => (
          <div
            onClick={
              filter.sorting_key
                ? () => handleSortLoans(filter.sorting_key, filter?.isNumber)
                : null
            }
            onKeyDown={null}
            tabIndex={-1}
            role={filter.isLabel ? 'none' : 'button'}
            key={filter.label}
            className={`p-0 d-flex flex-row align-items-center col-${filter.col} my-auto text-shadow text-f6 text-nowrap`}>
            {filter.withIcon && (
              <img
                alt="sort"
                src="./assets/images/sort.svg"
                className="me-1"
                style={{ width: '1rem', height: '1rem' }}
              />
            )}
            {!filter.isHidden && (
              <p className={`${filter.isRight ? 'ms-auto' : 'text-start'}`}>{filter.label}</p>
            )}
          </div>
        ))}
      </div>
    </div>
    {children && (
      <div className="h-65vh overflow-auto pe-3" style={{ width: 'calc(100% + 1rem)' }}>
        {children}
      </div>
    )}
  </div>
);

Filter.propTypes = {
  children: PropTypes.any.isRequired,
  filters: PropTypes.array.isRequired,
  handleSortLoans: PropTypes.func.isRequired,
};

export const List = ({ data, itemList, isLoading, filter }) => {
  if (isLoading) {
    return (
      <div className="mt-3 h-65vh overflow-auto d-flex flex-column gap-3">
        <TransactionItemPlaceholder />
        <TransactionItemPlaceholder />
        <TransactionItemPlaceholder />
        <TransactionItemPlaceholder />
      </div>
    );
  }
  return (
    <div>
      {data
        .filter(filter)
        .map((item) => React.cloneElement(itemList, { data: item, key: item.id }))}
    </div>
  );
};

List.propTypes = {
  data: PropTypes.any,
  itemList: PropTypes.any.isRequired,
  isLoading: PropTypes.bool,
  filter: PropTypes.func,
};
List.defaultProps = {
  isLoading: null,
  filter: null,
  data: null,
};

export const ItemLayout = ({ onClick, note, noteType, withHover, children }) => (
  <div className="my-2 mw-100">
    <div
      role={isBrowser ? 'none' : 'button'}
      tabIndex={-1}
      onKeyDown={isBrowser ? null : onClick}
      onClick={isBrowser ? null : onClick}
      className={`row bg-lighter rounded-extra py-3 px-xl-4 px-3 position-relative mx-100 mx-auto ${
        withHover ? 'hover-item' : ''
      }`}>
      {children.map((child, index) => (
        <div
          key={index}
          className={`col-md-${child.props?.col} col-${child?.props?.mobileCol || '6'} my-auto ${
            index > 0 && index < children.length - 1 ? 'd-md-block d-none' : ''
          } ${child.props?.isRight || child.props?.isright === 'true' ? 'ms-auto text-end' : ''}`}>
          {child}
        </div>
      ))}
    </div>
    {noteType && note && (
      <div
        className={`row bg-${noteType} text-light text-f6 rounded-extra pb-2 mx-100 mx-auto`}
        style={{ marginTop: '-1rem', paddingTop: '1.5rem' }}>
        <p className="text-center">{note}</p>
      </div>
    )}
  </div>
);

ItemLayout.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
  note: PropTypes.string,
  noteType: PropTypes.string,
  withHover: PropTypes.bool,
};

ItemLayout.defaultProps = {
  note: null,
  noteType: null,
  withHover: true,
};

export const IconWithLabel = ({ icon, label, subLabel }) => (
  <div className="d-flex flex-row align-items-center">
    <CurrencyIcon currencyCode={icon} className="m-0 me-3" />
    <div>
      <b className="text-f5 text-dark">{label}</b>

      <p className="d-none d-md-block text-shadow text-f6">{subLabel}</p>
      <p className="d-block d-md-none text-shadow text-f6">{subLabel}</p>
    </div>
  </div>
);
IconWithLabel.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
};
IconWithLabel.defaultProps = {
  subLabel: null,
};

export const Tabs = ({ keys, children, renderInfoPopup }) => {
  const [currentTab, setCurrentTab] = useState(keys[0]);
  const [showInfoPopup, setShowInfoPopup] = useState(false);

  const renderInfoIcon = () => (
    <div
      role="button"
      className="d-none d-md-none"
      tabIndex={-1}
      onMouseEnter={() => setShowInfoPopup(true)}
      onKeyDown={null}
      onMouseLeave={() => setShowInfoPopup(false)}>
      <i
        className={`${
          showInfoPopup ? 'text-primary' : 'text-shadow'
        } icon-question-other ms-auto text-f4 `}
      />
      {showInfoPopup && renderInfoPopup()}
    </div>
  );

  return (
    <>
      <div className="flex-row-center mb-4">
        <div className="bg-light rounded-4 flex-row-center border border-shadow col-12 col-md-5">
          {keys.map((key) => (
            <button
              key={key.keyName}
              type="button"
              style={{ height: '2.5rem' }}
              className={`toggle-item ${
                currentTab.keyName === key.keyName && 'active'
              } btn w-50 p-2 rounded-3`}
              onClick={() => setCurrentTab(key)}>
              {key.label}
            </button>
          ))}
        </div>
        {renderInfoIcon()}
      </div>
      {children.filter((child) => child.props.keyName === currentTab.keyName)}
    </>
  );
};

Tabs.propTypes = {
  keys: PropTypes.array.isRequired,
  children: PropTypes.any.isRequired,
  renderInfoPopup: PropTypes.func,
};
Tabs.defaultProps = {
  renderInfoPopup: null,
};
